require("../common/bootstrap");

import { createApp } from "vue";
import mitt from 'mitt';

import VueScreen from 'vue-screen'; // For watching breakpoints and screen size.

import api from './api';
import store from './store';
import router from './router';
import Config from '@/config/config.js';
import AuthMixins from '@/mixins/AuthMixins';
import AnalyticsMixins from '@/mixins/AnalyticsMixins';

import intersection from "v-intersection";
import ls from 'localstorage-slim';

const appCore = {
	mixins: [AuthMixins, AnalyticsMixins],

  data() {
		return {

		}
	},

	created() {
		this.reloadMe();
		this.emitter.on("refresh:user",this.reloadViaAPI);
		this.emitter.on("logout",this.logout);
		this.emitter.on('rainbow-lock',this.rainbow_lock);

		window.triggerLinkEvent = ((value) => {
			this.emitter.emit("openModal",{'name':'OrgCompare', persistent: true});
		})
	},

	beforeUnmount() {
		this.emitter.off('refresh:user',this.reloadViaAPI);
		this.emitter.off("logout",this.logout);
		window.triggerLinkEvent = null;
	},

	mounted() {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		if (urlParams.get('compare')) {
			this.emitter.emit("openModal",{'name':'OrgCompare', persistent: true, 'compare':urlParams.get('compare')});
		}
	},

	methods: {
		reloadMe () {
			// Load info about the user.
			let enc_user = document.head.querySelector('meta[name="user"]').content;
			if (enc_user) {
				this.updateUser(enc_user);

				// The user is newly logging in. Do anything special at this point.
				if (localStorage.getItem("token") == "undefined") {
					ls.remove('escRecommendedOrgs');
				}

				localStorage.setItem("token",this.$store.getters.getUser.token);
			} else {
				localStorage.setItem("token","undefined");
			}
		},
		reloadViaAPI() {
			let payload = {}
			return this.$api.loadMe(payload).then(
				(response) => {
					if (response.data.status == 'success') {
						this.updateUser(response.data.enc_user);
					}
				}
			).catch((response) => {
				console.log("Could not load user.", response);
			});
		},
		logout() {
			window.location = document.head.querySelector('meta[name="logout_url"]').content;
		},
		rainbow_lock(params) {
			//console.log("Rainbow Lock",params,this.$refs.main);
			if (this.$refs.main !== undefined) {
				if (params.fixed) {
					this.$refs.main.classList.add("search-fixed");
				} else {
					this.$refs.main.classList.remove("search-fixed");
				}
				if (params.expanded) {
					this.$refs.main.classList.add("search-expanded");
				} else {
					this.$refs.main.classList.remove("search-expanded");
				}
			}
		}
	}
}

Config.white_label = (document.head.querySelector('meta[name="white_label"]')) ? true : false;
Config.test_env = (document.head.querySelector('meta[name="env"]')) ? true : false;
Config.version = (document.head.querySelector('meta[name="version"]')) ? (document.head.querySelector('meta[name="version"]')).content : '1';

window.app = createApp(appCore);
const emitter = mitt();

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import Filters from "@/common/filters";

// Autoload all the blocks in the root folder
let requireBlocksComponent;

requireBlocksComponent = require.context("./components/blocks", true, /\.vue$/);
requireBlocksComponent.keys().forEach((fileName) => {
	let componentConfig = requireBlocksComponent(fileName);
	let componentName = upperFirst(
		camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
	);
	app.component(
		`Block${componentName}`,
		componentConfig.default || componentConfig
	);
});

// Autoload all the blocks in the heros sub folder
requireBlocksComponent = require.context("./components/blocks/heros", true, /\.vue$/);
requireBlocksComponent.keys().forEach((fileName) => {
	let componentConfig = requireBlocksComponent(fileName);
	let componentName = upperFirst(
		camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
	);
	app.component(
		`Block${componentName}`,
		componentConfig.default || componentConfig
	);
});

// Autoload all the svgs
const requireSvgsComponent = require.context("./components/svgs", true, /\.vue$/);
requireSvgsComponent.keys().forEach((fileName) => {
	let componentConfig = requireSvgsComponent(fileName);
	let componentName = upperFirst(
		camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
	);
	app.component(
		`Svg${componentName}`,
		componentConfig.default || componentConfig
	);
});

app.use(store);
app.use(router);
app.use(VueScreen, 'tailwind');
app.use(intersection);

// Make a few things global
app.config.globalProperties.$store = store;
app.config.globalProperties.$router = router;
app.config.globalProperties.$api = api;
app.config.globalProperties.$config = Config;

app.config.globalProperties.$filters = Filters;
app.config.globalProperties.emitter = emitter;

app.mount("#app");
